export default __webpack_public_path__ + "static/media/fondo-student-dashboard-placeholder.55b76156.jpg";